<mat-toolbar class="bar-filler"></mat-toolbar>
<div>
    <div class="flex-container-center small-padding small-margin">
        <div class="item-image-holder flex-child">
            <img src="{{itemHolder.MenuItem.Picture}}" class="item-image" onerror="this.src='assets/img/placeholder.png'">
        </div>
        <div class="description-text">{{itemHolder.MenuItem.Description}}</div>
    </div>
    <div class="horizontal-center">
        <div class="label center-text">{{'Pages.ComboItem.Quantity' | translate}}</div>
        <div class="label center-text">{{itemHolder.MenuItem.ItemCount}}</div>
    </div>
    <div class="small-margin">
        <mat-form-field class="fill-parent-width">
            <mat-label>{{'Pages.ComboItem.Observation' | translate}}</mat-label>
            <input matInput [(ngModel)]="itemHolder.MenuItem.Comentary">
        </mat-form-field>
    </div>
    <div>
        <div *ngFor="let detailGroupPack of itemHolder.DetailGroupPacks" class="detail-group">
            <div class="sticky" id="{{detailGroupPack.DetailGroup.ID}}">
                <div class="flex-container-center list-group-header disable-select">
                    <div class="small-padding">
                        <div class="list-group-header-label">{{detailGroupPack.DetailGroup.Name}}</div>
                        <div class="list-group-header-detail">{{detailGroupPack.DetailGroup.Description}}</div>
                        <div *ngIf="detailGroupPack.DetailGroup.LimitSelection === true || detailGroupPack.DetailGroup.LimitMacroSelection === true" class="list-group-header-detail small-margin small-padding">{{detailGroupPack.LimitSelectionDescription}}</div>
                        <div *ngIf="detailGroupPack.DetailGroup.Type == 1" class="list-group-header-detail">({{'Pages.ComboItem.Mandatory' | translate}})</div>
                    </div>
                    <div class="filler"></div>
                    <div *ngIf="detailGroupPack.DetailGroup.AlwaysShowList !== true" class="small-padding small-margin">
                        <button *ngIf="detailGroupPack.ShowList === false && detailGroupPack.HasSelection === false" mat-stroked-button color="accent" (click)="showList(detailGroupPack, true)">{{'Pages.ComboItem.Choose' | translate}}</button>
                        <button *ngIf="detailGroupPack.ShowList === false && detailGroupPack.HasSelection === true" mat-stroked-button color="accent" (click)="showList(detailGroupPack, true)">{{'Pages.ComboItem.Change' | translate}}</button>
                        <button *ngIf="detailGroupPack.ShowList === true" mat-icon-button color="accent" (click)="showList(detailGroupPack, false)">
                            <mat-icon>expand_less</mat-icon>
                        </button>
                    </div>
                </div>
            </div>
            <div *ngIf="detailGroupPack.ShowList === true || detailGroupPack.DetailGroup.AlwaysShowList === true">
                <div *ngFor="let detail of detailGroupPack.DetailList">
                    <div class="disable-select">
                        <div class="flex-container-center list-cell">
                            <div *ngIf="detail.ShowIcon" class="detail-thumbnail-holder small-margin">
                                <img src="{{detail.Icon}}" class="detail-thumbnail" onerror="this.src='assets/img/placeholder.png'">
                            </div>
                            <div class="small-padding">
                                <div class="list-cell-label">{{detail.Name}}</div>
                            </div>
                            <div *ngIf="detail.OutOfStock === false" class="float-right flex-container-center disable-select" (click)="detailTap(detail, detailGroupPack)">
                                <div class="list-cell-price">{{detail.PriceString}}</div>
                                <div *ngIf="detail.Type == 0 && detail.MaxCount > 1" mat-ripple class="cell-toggle">
                                    <p>{{detail.CurrentCount}}</p>
                                </div>
                                <div *ngIf="detail.Type == 0 && detail.MaxCount === 1" mat-ripple [ngClass]="{'cell-toggle':detail.CurrentCount === 0, 'cell-toggle-filled':detail.CurrentCount === 1}"></div>
                                <div *ngIf="detail.Type == 1" mat-ripple [ngClass]="{'cell-switch':detail.CurrentCount === 0, 'cell-switch-filled':detail.CurrentCount === 1}"></div>
                            </div>
                            <div *ngIf="detail.OutOfStock === true" class="float-right flex-container-center disable-select">
                                <div class="list-cell-price">{{'Pages.ComboItem.Unavailable' | translate}}</div>
                            </div>
                        </div>
                        <mat-divider></mat-divider>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <mat-toolbar class="bar-filler">
        <mat-toolbar-row>
            <P></P>
        </mat-toolbar-row>
        <mat-toolbar-row>
            <P></P>
        </mat-toolbar-row>
    </mat-toolbar>
</div>
<mat-toolbar color="primary" class="top-bar" id="topbar">
    <button mat-icon-button (click)="back()">
        <mat-icon>arrow_back</mat-icon>
    </button>
    <div>{{itemHolder.Name}}</div>
</mat-toolbar>
<mat-toolbar *ngIf="showBottomBar === true" matRipple #bottomBar id="bottomBar" [matRippleDisabled]="true" [matRippleColor]="rippleColor" color="primary" class="bottom-bar">
    <mat-toolbar-row>
        <div class="big-price-text">{{currentPriceString}}</div>
    </mat-toolbar-row>
    <mat-toolbar-row>
        <button mat-flat-button color="accent" disabled="{{!canSave}}" (click)="save()" class="fill-parent-width">{{'Pages.ComboItem.Add' | translate}}</button>
    </mat-toolbar-row>
</mat-toolbar>
